module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ctn-patrimonial-landscape"
  }, [_c('h1', [_vm._v("Paysage Patrimonial de " + _vm._s(_vm.client.firstname) + " " + _vm._s(_vm.client.lastname))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("\n\t\t\tComplétez votre paysage patrimonial étape par étape ou librement en naviguant par thématique. Cliquez sur \"Sauvegarder\" pour enregistrer votre saisie au fur et à mesure. Vous pourrez le reprendre à tout moment en vous reconnectant. La validation de votre paysage patrimonial sera effective qu'une fois l'étape de signature réalisée.\n\t\t")]), _vm._v(" "), _c('patrimonial-landscape', {
    attrs: {
      "user": _vm.client
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01fa38cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/Contacts/PatrimonialLandscapeUpdate.vue
// module id = 1063
// module chunks = 0